import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios, {AxiosProgressEvent} from 'axios'

const curs_api = '/api/online-course/'
const pln_api = '/api/planning/'
const mtr_api = '/api/material/'
const qs_api = '/api/question/'
const et_api = '/api/exam-type/'
const n_api = '/api/o-news/'
const pref = 'online-'
const ol = '/api/ol/'
const score = '/api/score/'
const st = '/api/subtitle/'
const progress = '/api/progress/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data?.errors || null)
  }
}

export const OfflineCourses = createAsyncThunk(`${pref}off-courses`, (_, thunkAPI) =>
  handleRequest(get(`${curs_api}offline-courses`), thunkAPI)
)

export const OffCourse = createAsyncThunk(`${pref}off-course-details`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}off-course-details/${id}`), thunkAPI)
)

export const CourseSections = createAsyncThunk(`${pref}course-sections`, (_, thunkAPI) =>
  handleRequest(get(`${curs_api}course-sections`), thunkAPI)
)

export const OnlineCourses = createAsyncThunk(`${pref}`, (params: {}, thunkAPI) =>
  handleRequest(get(`${curs_api}list`, params), thunkAPI)
)

export const GetLecs = createAsyncThunk(`lecs`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}get-lecs/${id}`), thunkAPI)
)

export const CourseSubtitles = createAsyncThunk(`course-subtitles`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-subtitles/${id}`), thunkAPI)
)

export const createOnlineCourse = createAsyncThunk(`${pref}create`, (data: {}, thunkAPI) =>
  handleRequest(post(`${curs_api}store`, data), thunkAPI)
)

export const editOnlineCourse = createAsyncThunk(`${pref}edit`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}edit/${id}`), thunkAPI)
)

export const showOnlineCourse = createAsyncThunk(`${pref}show`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}show/${id}`), thunkAPI)
)

export const deleteOnlineCourse = createAsyncThunk(`${pref}delete`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}destroy/${id}`), thunkAPI)
)

// planning
export const Plannings = createAsyncThunk(`${pref}plng`, (_, thunkAPI) =>
  handleRequest(get(`${pln_api}planning`), thunkAPI)
)

export const createPlanning = createAsyncThunk(`${pref}create-p`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}planning-store`, data), thunkAPI)
)

export const editPlanning = createAsyncThunk(`${pref}edit`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}edit/${id}`), thunkAPI)
)

export const deletePlanning = createAsyncThunk(`${pref}delete`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}destroy/${id}`), thunkAPI)
)

export const PlanningPrograms = createAsyncThunk(`${pref}pros`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}programs/${id}`), thunkAPI)
)

export const createProgram = createAsyncThunk(`${pref}create-pr`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}store-program`, data), thunkAPI)
)

export const reorderPrograms = createAsyncThunk(`reorder-programs`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}reorder-programs`, data), thunkAPI)
)

export const editProgram = createAsyncThunk(`${pref}edit-pr`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}edit-program/${id}`), thunkAPI)
)

export const deleteProgram = createAsyncThunk(`${pref}delete-pr`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}destroy-program/${id}`), thunkAPI)
)

export const OnlineCourse = createAsyncThunk(`${pref}oc`, (_, thunkAPI) =>
  handleRequest(get(`${pln_api}online-courses`), thunkAPI)
)

export const PlanningCourses = createAsyncThunk(`${pref}courses`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}courses/${id}`), thunkAPI)
)

export const getCourseCredit = createAsyncThunk(`course-credits`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-credits/${id}`), thunkAPI)
)

export const createCourse = createAsyncThunk(`${pref}create-cs`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}store-course`, data), thunkAPI)
)

export const reorderCourses = createAsyncThunk(`reorder-courses`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}reorder-courses`, data), thunkAPI)
)

export const editCourse = createAsyncThunk(`${pref}edit-cs`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}edit-course/${id}`), thunkAPI)
)

export const toggleCourse = createAsyncThunk(`tc`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}toggle-course/${id}`), thunkAPI)
)

export const deleteCourse = createAsyncThunk(`${pref}delete-cs`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}destroy-course/${id}`), thunkAPI)
)

export const AddStdsToCourse = createAsyncThunk(`${pref}astc`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}add-std-to-course`, data), thunkAPI)
)

export const CourseStudents = createAsyncThunk('course-students', (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}course-students`, data), thunkAPI)
)

export const deleteStudentCourse = createAsyncThunk('std-course-delete', (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}rm-std-course/${id}`), thunkAPI)
)

export const CourseStudentsDelete = createAsyncThunk('stds-course-delete', (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}rm-stds-course`, data), thunkAPI)
)

export const CourseStatistic = createAsyncThunk(`statistics`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}statistics/${id}`), thunkAPI)
)

// materials
export const onlineMaterials = createAsyncThunk('mtr', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}materials/${id}`), thunkAPI)
)

export const EdtSyllabus = createAsyncThunk('edit-syllabus', (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}edit-syllabus/${id}`), thunkAPI)
)

export const DestSyllabus = createAsyncThunk('destroy-syllabus', (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}destroy-syllabus/${id}`), thunkAPI)
)

export const updateSyllabus = createAsyncThunk(`${pref}us`, (data: {}, thunkAPI) =>
  handleRequest(post(`${curs_api}update-syllabus`, data), thunkAPI)
)

export const updateLesName = createAsyncThunk(`${pref}uln`, (data: {}, thunkAPI) =>
  handleRequest(post(`${mtr_api}update-lesson-name`, data), thunkAPI)
)

export const CreateLesson = createAsyncThunk(`${pref}cln`, (data: {}, thunkAPI) =>
  handleRequest(post(`${mtr_api}store-lesson`, data), thunkAPI)
)

export const Lessons = createAsyncThunk('lessons', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}lessons/${id}`), thunkAPI)
)

export const DestLes = createAsyncThunk('destroy-lesson', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}destroy-lesson/${id}`), thunkAPI)
)

export const CreateMaterial = createAsyncThunk(
  `${pref}cm`,
  ({formData, onUploadProgress}: any, thunkAPI) =>
    handleRequest(
      post(`${mtr_api}store`, formData, {
        onUploadProgress,
      }),
      thunkAPI
    )
)

export const ToggleMaterial = createAsyncThunk('toggle', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}toggle/${id}`), thunkAPI)
)

export const DestMat = createAsyncThunk('destroy-material', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}destroy-material/${id}`), thunkAPI)
)

export const EditMat = createAsyncThunk('edit', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}edit/${id}`), thunkAPI)
)

export const EditWelMsg = createAsyncThunk('edit-wm', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}edit-wm/${id}`), thunkAPI)
)

export const updateWM = createAsyncThunk(`${pref}uwm`, (data: {}, thunkAPI) =>
  handleRequest(post(`${mtr_api}update-wm`, data), thunkAPI)
)

export const deleteWC = createAsyncThunk(`del-wc`, (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}del-wc/${id}`), thunkAPI)
)

export const Documents = createAsyncThunk('docs', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}docs/${id}`), thunkAPI)
)

export const CreateDocument = createAsyncThunk(`${pref}st-doc`, (data: {}, thunkAPI) =>
  handleRequest(post(`${mtr_api}store-docs`, data), thunkAPI)
)

export const EditDocs = createAsyncThunk('edit-docs', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}edit-docs/${id}`), thunkAPI)
)

export const DestDoc = createAsyncThunk('destroy-doc', (id: string, thunkAPI) =>
  handleRequest(get(`${mtr_api}destroy-doc/${id}`), thunkAPI)
)

export const createMExam = createAsyncThunk(`${pref}create`, (data: {}, thunkAPI) =>
  handleRequest(post(`${et_api}store`, data), thunkAPI)
)

export const EditMExam = createAsyncThunk('ed-m-exam', (id: string, thunkAPI) =>
  handleRequest(get(`${et_api}edit/${id}`), thunkAPI)
)

export const deleteMExam = createAsyncThunk(`${pref}delete`, (params: {}, thunkAPI) =>
  handleRequest(
    get(`${et_api}destroy`, {
      params,
    }),
    thunkAPI
  )
)

export const Questions = createAsyncThunk('list', (id: string, thunkAPI) =>
  handleRequest(get(`${qs_api}list/${id}`), thunkAPI)
)

export const CreateQuestion = createAsyncThunk(`cr-quest`, (data: {}, thunkAPI) =>
  handleRequest(post(`${qs_api}store`, data), thunkAPI)
)

export const editQuestion = createAsyncThunk(`q-edit`, (id: string, thunkAPI) =>
  handleRequest(get(`${qs_api}edit/${id}`), thunkAPI)
)

export const UpdateQuestion = createAsyncThunk(`ud-ques`, (data: {}, thunkAPI) =>
  handleRequest(post(`${qs_api}update`, data), thunkAPI)
)

export const deleteQuestion = createAsyncThunk(`q-delete`, (id: string, thunkAPI) =>
  handleRequest(get(`${qs_api}destroy/${id}`), thunkAPI)
)

export const deleteQuesCat = createAsyncThunk(`qc-delete`, (data: {}, thunkAPI) =>
  handleRequest(post(`${qs_api}destroy-cat`, data), thunkAPI)
)

export const DownloadQuesTemplate = createAsyncThunk('dqt', async (_) => {
  const response = await get(`${qs_api}dload-temp`, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'QuestionTemplate.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const ImportQuestions = createAsyncThunk(`im-ques`, (data: {}, thunkAPI) =>
  handleRequest(post(`${qs_api}imp-xl-quest`, data), thunkAPI)
)

export const ExportQuestions = createAsyncThunk('eq', async (id: string) => {
  const response = await axios.get(`${qs_api}xprt-ques/${id}`, {
    responseType: 'blob',
  })

  const url = window.URL.createObjectURL(response.data)

  const link = document.createElement('a')

  link.href = url
  link.download = 'Questions.xlsx'

  document.body.appendChild(link)

  link.click()

  link.remove()

  window.URL.revokeObjectURL(url)

  return true
})

export const printQuestions = createAsyncThunk(`pq`, (id: string, thunkAPI) =>
  handleRequest(get(`${qs_api}prt-ques/${id}`), thunkAPI)
)

export const listNews = createAsyncThunk(`ln`, (id: string, thunkAPI) =>
  handleRequest(get(`${n_api}list/${id}`), thunkAPI)
)

export const createNews = createAsyncThunk(`nc`, (data: {}, thunkAPI) =>
  handleRequest(post(`${n_api}store`, data), thunkAPI)
)

export const editNews = createAsyncThunk(`en`, (id: string, thunkAPI) =>
  handleRequest(get(`${n_api}edit/${id}`), thunkAPI)
)

export const toggleNews = createAsyncThunk(`tn`, (id: string, thunkAPI) =>
  handleRequest(get(`${n_api}toggle/${id}`), thunkAPI)
)

export const deleteNews = createAsyncThunk(`tn`, (id: string, thunkAPI) =>
  handleRequest(get(`${n_api}destroy/${id}`), thunkAPI)
)

export const OnlineLecs = createAsyncThunk(`lecs`, (params: {}, thunkAPI) =>
  handleRequest(get(`${ol}list`, params), thunkAPI)
)

export const createOnlineLec = createAsyncThunk(`cl`, (data: {}, thunkAPI) =>
  handleRequest(post(`${ol}store`, data), thunkAPI)
)

export const editLec = createAsyncThunk(`el`, (id: string, thunkAPI) =>
  handleRequest(get(`${ol}edit/${id}`), thunkAPI)
)

export const EmailtoOnLec = createAsyncThunk(`el`, (data: {}, thunkAPI) =>
  handleRequest(post(`${ol}email`, data), thunkAPI)
)

export const DeleteOL = createAsyncThunk(`dl`, (id: string, thunkAPI) =>
  handleRequest(get(`${ol}destroy/${id}`), thunkAPI)
)

export const ViewOL = createAsyncThunk(`vl`, (id: string, thunkAPI) =>
  handleRequest(get(`${ol}view/${id}`), thunkAPI)
)

export const UpdateEmailLecAcc = createAsyncThunk(`vl`, (id: string, thunkAPI) =>
  handleRequest(get(`${ol}update-lec-account/${id}`), thunkAPI)
)

export const GetOnlineLecs = createAsyncThunk(`ll`, (_, thunkAPI) =>
  handleRequest(get(`${ol}get-lecturers`), thunkAPI)
)

export const CreateUserForLecs = createAsyncThunk(`el`, (data: {}, thunkAPI) =>
  handleRequest(post(`${ol}create-user`, data), thunkAPI)
)

export const LecturerExcel = createAsyncThunk('lecturer-excel', async (params: {}) => {
  const response = await get(`${ol}excel-lecturers`, {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Teaching Staff.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const PrintLecturers = createAsyncThunk(`pl`, (params: {}, thunkAPI) =>
  handleRequest(get(`${ol}print-lecturers`, params), thunkAPI)
)

export const CourseLink = createAsyncThunk(`cl`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-link/${id}`), thunkAPI)
)

export const CreateCourseLink = createAsyncThunk(`scl`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}store-link`, data), thunkAPI)
)

export const CourseLec = createAsyncThunk(`fld`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}course-lec/${id}`), thunkAPI)
)

export const UpdateCourseLec = createAsyncThunk(`ul`, (data: {}, thunkAPI) =>
  handleRequest(post(`${curs_api}update-course-lec`, data), thunkAPI)
)

export const PCourseLecDetails = createAsyncThunk(`lec-details`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-lec-details/${id}`), thunkAPI)
)

export const PCourseLec = createAsyncThunk(`fld`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-lec/${id}`), thunkAPI)
)

export const PUpdateCourseLec = createAsyncThunk(`ul`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}update-course-lec`, data), thunkAPI)
)

export const MarkAsComplete = createAsyncThunk(`mark-as-complete`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}mark-as-complete`, data), thunkAPI)
)

export const ExamIntervalUpdate = createAsyncThunk(`exam-interval`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}exam-interval`, data), thunkAPI)
)

export const OnlineEvReport = createAsyncThunk(`oc-ev-rep`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}oc-ev-rep/${id}`), thunkAPI)
)

export const OnlineEvReportPrt = createAsyncThunk(`oc-ev-rep-prt`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}oc-ev-rep-prt/${id}`), thunkAPI)
)

export const OnlineEvReportExcel = createAsyncThunk('oc-ev-rep-xl', async (id: string) => {
  const response = await axios.get(`${pln_api}oc-ev-rep-xl/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Evaluation_Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const StudentReponses = createAsyncThunk(`std-resp`, (id: string, thunkAPI) =>
  handleRequest(get(`${score}student-responses/${id}`), thunkAPI)
)

export const DldStdAns = createAsyncThunk('dld-std-ans', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post(`${score}dld-std-ans`, data, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/zip',
      },
    })
    if (res.data.type === 'application/json') {
      const text = await res.data.text()
      const errorData = JSON.parse(text)
      return thunkAPI.rejectWithValue(errorData.message || 'Download failed')
    }

    return res.data
  } catch (error: any) {
    if (error.response?.data) {
      if (error.response.data instanceof Blob) {
        const text = await error.response.data.text()
        const errorData = JSON.parse(text)
        return thunkAPI.rejectWithValue(errorData.message || errorData.errors)
      }
      return thunkAPI.rejectWithValue(error.response.data.errors || error.response.data.message)
    }
    return thunkAPI.rejectWithValue(error.message)
  }
})

export const ProjectScoreStore = createAsyncThunk(`store-project-score`, (data: {}, thunkAPI) =>
  handleRequest(post(`${score}store-project-score`, data), thunkAPI)
)

export const EssayScoreStore = createAsyncThunk(`store-essay-score`, (data: {}, thunkAPI) =>
  handleRequest(post(`${score}store-essay-score`, data), thunkAPI)
)

export const StudentScores = createAsyncThunk(`student-scores`, (id: string, thunkAPI) =>
  handleRequest(get(`${score}student-scores/${id}`), thunkAPI)
)

export const manageScoreStatus = createAsyncThunk(`mng-score-status`, (data: {}, thunkAPI) =>
  handleRequest(post(`${score}mng-score-status`, data), thunkAPI)
)

export const updateStudentScore = createAsyncThunk(`update-student-score`, (data: {}, thunkAPI) =>
  handleRequest(post(`${score}update-student-score`, data), thunkAPI)
)

export const CurseDetails = createAsyncThunk(`course-details`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-details/${id}`), thunkAPI)
)

export const CurseContents = createAsyncThunk(`course-contents`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}course-contents/${id}`), thunkAPI)
)

export const Exams = createAsyncThunk(`exam-types`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}exam-types/${id}`), thunkAPI)
)

export const getUsrs = createAsyncThunk(`users`, (_, thunkAPI) =>
  handleRequest(get(`${pln_api}users`), thunkAPI)
)

export const AddUserToCourse = createAsyncThunk(`add-user`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}add-user`, data), thunkAPI)
)

export const SwitchStatus = createAsyncThunk(`switch-status`, (id: string, thunkAPI) =>
  handleRequest(get(`${pln_api}switch-status/${id}`), thunkAPI)
)

export const emailToRecord = createAsyncThunk(`email`, (data: {}, thunkAPI) =>
  handleRequest(post(`${pln_api}email`, data), thunkAPI)
)

export const Subtitles = createAsyncThunk(`subtitles`, (id: string, thunkAPI) =>
  handleRequest(get(`${st}subtitles/${id}`), thunkAPI)
)

export const SubtitleStore = createAsyncThunk(`store`, (data: {}, thunkAPI) =>
  handleRequest(post(`${st}store`, data), thunkAPI)
)

export const SubtitleEdit = createAsyncThunk(`edit`, (id: string, thunkAPI) =>
  handleRequest(get(`${st}edit/${id}`), thunkAPI)
)

export const SubtitleDel = createAsyncThunk(`destroy`, (id: string, thunkAPI) =>
  handleRequest(get(`${st}destroy/${id}`), thunkAPI)
)

export const CourseProgressRep = createAsyncThunk(`progress-types`, (id: string, thunkAPI) =>
  handleRequest(get(`${progress}progress-types/${id}`), thunkAPI)
)

export const ProgDetails = createAsyncThunk(`progress-details`, (data: {}, thunkAPI) =>
  handleRequest(post(`${progress}progress-details`, data), thunkAPI)
)

export const PrgOverview = createAsyncThunk(`progress-overview`, (id: string, thunkAPI) =>
  handleRequest(get(`${progress}progress-overview/${id}`), thunkAPI)
)

export const AllCourses = createAsyncThunk(`get-courses`, (_, thunkAPI) =>
  handleRequest(get(`${curs_api}get-courses`), thunkAPI)
)

export const videoSections = createAsyncThunk(`video-sections`, (id: string, thunkAPI) =>
  handleRequest(get(`${curs_api}video-sections/${id}`), thunkAPI)
)

interface UploadLessonPayload {
  formData: FormData
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
}

export const UploadLesson = createAsyncThunk(
  'upload-video',
  ({formData, onUploadProgress}: UploadLessonPayload, thunkAPI) =>
    handleRequest(
      post(`${mtr_api}upload-video`, formData, {
        onUploadProgress,
      }),
      thunkAPI
    )
)

export const OcCourses = createAsyncThunk(`oc-courses`, (_, thunkAPI) =>
  handleRequest(get(`${mtr_api}oc-courses`), thunkAPI)
)

export const UploadDocs = createAsyncThunk('upload-docs', (data: FormData, thunkAPI) =>
  handleRequest(post(`${mtr_api}upload-docs`, data), thunkAPI)
)

type OnlineState = {
  record: any
  records: any
  errors: any
}

const initialState: OnlineState = {
  records: {data: []},
  record: {},
  errors: '',
}

export const onlineSlice = createSlice({
  name: 'online',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: () => {},
})

export const {reset} = onlineSlice.actions
export default onlineSlice.reducer
